<!-- End of the scrolling rows on a phone: a spinner (the sentinel) or, after a failed request, a retry button. -->
<ng-template #loadMoreTpl>
  @if (infiniteScroll && hasMore) { @if (loadFailed) {
  <div class="load-more">
    <button mat-button type="button" (click)="retryLoadMore()">Could not load more. Try again</button>
  </div>
  } @else {
  <div #sentinel class="load-more" aria-hidden="true">
    <span class="load-more-ring"></span>
  </div>
  } }
</ng-template>

<ng-template #cellContent let-row let-col="col">
  <div class="cell-container">
    @if (row[col.key]?.iconLeading) {
    <svg-icon
      src="{{ row[col.key]?.iconLeading }}"
      [svgStyle]="{ 'width.px': 14, 'height.px': 14 }"
      [class.icon-leading]="true"
      [matTooltip]="row[col.key]?.tooltipText !== undefined ? row[col.key]?.tooltipText : null"
    ></svg-icon>
    } @if (!row[col.key]?.routerLink) { @if (!row[col.key]?.menus) {
    <span class="span-styling" [matTooltip]="row[col.key]?.value | formatCell">
      @if (!row[col.key]?.linkCallback) { @if (!row[col.key]?.value2) {
      {{ row[col.key]?.value | formatCell }}
      } @else {
      {{ row[col.key]?.value | formatCell }}
      <span class="concrete-grey span-styling">{{ row[col.key]?.value2 | formatCell }}</span>
      } } @else {
      <a href="#" target="_blank" (click)="_linkCallback($event, row)">
        {{ row[col.key]?.value | formatCell }}
      </a>
      }
    </span>
    } } @else {
    <a
      href="{{ row[col.key]?.routerLink }}"
      rel="noopener"
      target="_blank"
      [matTooltip]="row[col.key]?.value | formatCell"
    >
      {{ row[col.key]?.value | formatCell }}
    </a>
    }
  </div>
</ng-template>

@if (showSum) {
<div class="result-count-label">{{ sumLabel | translate }}: {{ totalItems }}</div>
} @if (cardsActive) {
<div class="table-cards" [class.compact]="phoneLayout === 'rows'">
  <div class="card-toolbar">
    @if (bulkEnabled) {
    <mat-checkbox
      class="card-select-all"
      [aria-label]="'SHARED.TABLE.SELECT_ALL' | translate"
      (click)="$event ? masterToggle() : null"
      [checked]="isAllSelected"
      [indeterminate]="!isAllSelected && isAnySelected"
    ></mat-checkbox>
    }
    <mat-form-field class="card-sort" subscriptSizing="dynamic">
      <mat-select
        [value]="cardSort.active"
        [placeholder]="'SHARED.TABLE.SORT_BY' | translate"
        [attr.aria-label]="'SHARED.TABLE.SORT_BY' | translate"
        (selectionChange)="onCardSortColumn($event.value)"
      >
        @for (col of sortableColumns; track col.key) {
        <mat-option [value]="col.key">{{ col.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <button
      mat-icon-button
      type="button"
      class="card-sort-direction"
      [disabled]="!cardSort.active"
      [attr.aria-label]="'SHARED.TABLE.SORT_DIRECTION' | translate"
      (click)="onCardSortDirection()"
    >
      <mat-icon>{{ cardSort.direction === "desc" ? "arrow_downward" : "arrow_upward" }}</mat-icon>
    </button>
  </div>
  @for (row of _dataSource; track $index; let i = $index) {
  <div
    class="table-card"
    [class.selectable]="bulkEnabled"
    [class.selected]="selectedIndex === i"
    (click)="cellClicked(row, i)"
  >
    @if (bulkEnabled) {
    <mat-checkbox
      class="card-checkbox"
      [aria-label]="'SHARED.TABLE.SELECT_ROW' | translate"
      (click)="$event.stopPropagation(); toggle(i)"
      [checked]="selectedItems.has(i)"
    ></mat-checkbox>
    } @for (col of tableColumns; track col.key) { @if (col.indicatorIcon) {
    <div class="card-indicator">
      <ng-container *ngTemplateOutlet="cellContent; context: { $implicit: row, col: col }"></ng-container>
    </div>
    } @else if (col.key === cardTitleKey) {
    <div class="card-title">
      <ng-container *ngTemplateOutlet="cellContent; context: { $implicit: row, col: col }"></ng-container>
    </div>
    } @else { @if (col.breakBefore) {
    <div class="card-break"></div>
    }
    <div class="card-field">
      <span class="card-label">{{ col.name }}</span>
      <span class="card-value">
        <ng-container *ngTemplateOutlet="cellContent; context: { $implicit: row, col: col }"></ng-container>
      </span>
    </div>
    } }
  </div>
  }
  <ng-container *ngTemplateOutlet="loadMoreTpl"></ng-container>
</div>
} @else {
<div class="table-scroll">
  <table
    style="width: 100% !important"
    mat-table
    [dataSource]="_dataSource"
    class="table"
    matSort
    matSortDisableClear
    [matSortActive]="cardSort.active"
    [matSortDirection]="cardSort.direction"
    (matSortChange)="announceSortChange($event)"
  >
    @if (bulkEnabled) {
    <ng-container matColumnDef="select" [sticky]="true">
      <th mat-header-cell *matHeaderCellDef class="checkbox">
        <mat-checkbox
          id="check-box-all"
          (click)="$event ? masterToggle() : null"
          [checked]="isAllSelected"
          [indeterminate]="!isAllSelected && isAnySelected"
        >
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row; let i = index" class="checkbox">
        <mat-checkbox
          id="{{ row['componentId'] ? 'check-box-' + row.componentId.value : null }}"
          (click)="$event ? toggle(i) : null"
          [checked]="this.selectedItems.has(i)"
        >
        </mat-checkbox>
      </td>
    </ng-container>
    } @for (col of tableColumns; track col.key; let i = $index) {
    <ng-container [matColumnDef]="col.key" [sticky]="col.isSticky">
      <th
        mat-header-cell
        [mat-sort-header]="col.isSortable ? col.key : ''"
        [disabled]="!col.isSortable"
        *matHeaderCellDef
        [ngClass]="col.key"
      >
        {{ col.name }}
      </th>
      <td
        [attr.data-column]="col.key"
        mat-cell
        [ngClass]="{ 'cell-min-width': !col.indicatorIcon }"
        *matCellDef="let element; let j = index"
        (click)="cellClicked(element, j)"
      >
        <ng-container *ngTemplateOutlet="cellContent; context: { $implicit: element, col: col }"></ng-container>
      </td>
    </ng-container>
    }
    <tr mat-header-row *matHeaderRowDef="columnKeys; sticky: true" class="column-header"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: columnKeys; let k = index"
      [ngClass]="{ selected: selectedIndex === k, border: row.$isHighlighted }"
    ></tr>
  </table>
  <ng-container *ngTemplateOutlet="loadMoreTpl"></ng-container>
</div>
} @if (totalItems !== undefined && !infiniteScroll) {
<div class="pagination-wrapper">
  <mat-paginator
    class="paginator-sticky"
    [pageIndex]="selectedPageIndex - 1"
    [length]="totalItems"
    [pageSize]="pageSize"
    (page)="handlePageEvent($event)"
    [showFirstLastButtons]="!bp.isPhone()"
    [hidePageSize]="bp.isPhone()"
    [pageSizeOptions]="pageSizeOptions"
    [selectConfig]="{ panelClass: 'paginator-select-panel' }"
  >
  </mat-paginator>
</div>
}
